import React from 'react';
import { Color } from 'modules/styles/colors';
import { Spacing } from 'modules/styles/variables';

import Box from 'components/UI/Layout/Box';
import FlexBox from 'components/UI/Layout/FlexBox';
import Spacer from 'components/UI/Layout/Spacer';
import Divider from 'components/UI/Divider';
import DefaultText from 'components/UI/Typography/DefaultText';

import WhiteBanner from 'screens/Billing/WhiteBanner';

import {
  ELIGIBILITY_CHART,
  ELIGIBILITY_BODY,
  ELIGIBILITY_CHART_HEADER_RIGHT,
  ELIGIBILITY_CHART_FOOTER
} from './constants';
import { MuiBox } from 'theme/material-ui';
import Typography from 'components/UI/Typography';

const FAEligibility = () => {
  return (
    <MuiBox>
      <WhiteBanner
        title="Financial Assistance Eligibility"
        subTitle="Review the information below to see if you meet the requirements for Financial Assistance"
      />

      <Divider />

      <FlexBox
        backgroundColor={Color.foreColor}
        vSpacing={Spacing.xLarge}
        hSpacing={Spacing.xLarge}
      >
        <Typography>{ELIGIBILITY_BODY}</Typography>
      </FlexBox>

      <Divider />

      <FlexBox
        backgroundColor={Color.foreColor}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        vSpacing={Spacing.large}
        hSpacing={Spacing.xLarge}
      >
        <Box flex={1}>
          <DefaultText>Family Size</DefaultText>
        </Box>
        <Box flex={2}>
          <DefaultText>{ELIGIBILITY_CHART_HEADER_RIGHT}</DefaultText>
        </Box>
      </FlexBox>

      <Box
        backgroundColor={Color.foreColor}
        vSpacingBottom={Spacing.xLarge}
        hSpacing={Spacing.xLarge}
        width="100%"
      >
        <Divider />
        {ELIGIBILITY_CHART.map(item => (
          <FlexBox
            aria-label={`Family size of ${item.familySize} is limited to ${item.incomeLimit}`}
            key={item.key}
          >
            <FlexBox
              backgroundColor={Color.foreColor}
              flexDirection="row"
              justifyContent="space-between"
              vSpacing={Spacing.large}
              width="100%"
            >
              <Typography>{item.familySize}</Typography>
              <Typography>{item.incomeLimit}</Typography>
            </FlexBox>
            <Divider />
          </FlexBox>
        ))}
        <Spacer size="small" />
        <DefaultText center>{ELIGIBILITY_CHART_FOOTER}</DefaultText>
      </Box>
    </MuiBox>
  );
};

export default FAEligibility;
